import { render, staticRenderFns } from "./TheTemples.vue?vue&type=template&id=152700d4&scoped=true&"
import script from "./TheTemples.vue?vue&type=script&lang=js&"
export * from "./TheTemples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152700d4",
  null
  
)

export default component.exports